import type { ReactElement } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import styles from "./Skeletons.module.css";

function Theme({ children }: { children: ReactElement }): ReactElement {
  return (
    <SkeletonTheme
      baseColor="var(--color-neutral-01)"
      highlightColor="var(--color-neutral-02)"
      borderRadius={8}
    >
      {children}
    </SkeletonTheme>
  );
}

const CARD_NAMES = [128, 96];

export function ListSkeleton(): ReactElement {
  return (
    <Theme>
      <div aria-hidden="true" className={styles.list}>
        <div className={styles.limits}>
          <Skeleton width={180} height={16} />
          <Skeleton width={72} height={12} />
        </div>
        {CARD_NAMES.map((width, index) => (
          <div key={index} className={styles.card}>
            <div className={styles.cardHead}>
              <Skeleton width={20} height={20} borderRadius={999} />
              <Skeleton width={width} height={18} />
              <Skeleton width={58} height={24} borderRadius={999} />
            </div>
            <div className={styles.strip}>
              {[0, 1, 2, 3].map((cell) => (
                <div key={cell} className={styles.stat}>
                  <Skeleton width={72} height={12} />
                  <Skeleton width={110} height={16} />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Theme>
  );
}

const SCOPE_ROWS = [56, 68, 48, 74, 52, 60, 46, 64, 58, 50, 62];

export function ScopeTreeSkeleton(): ReactElement {
  return (
    <Theme>
      <div aria-hidden="true" className={styles.scopes}>
        {SCOPE_ROWS.map((width, index) => (
          <div key={index} className={styles.scopeRow}>
            <div className={styles.scopeText}>
              <Skeleton width={width} height={14} />
              <Skeleton width={`${Math.min(70, width + 120)}%`} height={12} />
            </div>
            <Skeleton width={168} height={32} />
          </div>
        ))}
      </div>
    </Theme>
  );
}
